import isEmpty from 'lodash/isEmpty';
import tail from 'lodash/tail';
import cx from 'classnames';
import React from 'react';
import { getHighlightSelectionTipProps } from '../withHighlightSelectionTip';
import { TListBlockData } from '../types';
import { withHighlightAsText } from '../../Highlight/services/withHighlightAsText';
import { parseWithoutNonBreakingSpaces } from '../services/parseWithoutNonBreakingSpaces';
import { HighlightSelectionHint, TListHighlightBlockData } from '../../Highlight/types';
import { findListFragmentPositionInList } from '../services/findListFragmentPositionInList';

type TListHighlightBlockDataWithPosition = TListHighlightBlockData & { position: string };

export const renderListHelper = (
  { items, style }: TListBlockData,
  highlightData?: TListHighlightBlockDataWithPosition,
) => {
  if (isEmpty(items)) {
    return null;
  }

  const { items: highlightItems = [], position = '' } = highlightData || {};
  const highlightPositionOnThisLevel = +(position.split('.')?.[0] || 0);
  const highlightPositionOnNextLevel = tail(position.split('.')).join('.');
  const Tag = style === 'ordered' ? 'ol' : 'ul';

  return (
    <Tag
      className={cx({
        article__ol: style === 'ordered',
      })}
      {...getHighlightSelectionTipProps(HighlightSelectionHint.List)}
    >
      {items?.map(({ content, items }, index) => {
        const highlightItemHere = highlightItems?.[index - (highlightPositionOnThisLevel || 0)];

        return (
          <li
            key={index /* eslint-disable-line react/no-array-index-key */}
            className="article__li"
            {...getHighlightSelectionTipProps(HighlightSelectionHint.ListElement)}
          >
            <span {...getHighlightSelectionTipProps(HighlightSelectionHint.Text)}>
              {parseWithoutNonBreakingSpaces(withHighlightAsText(content, highlightItemHere?.content))}
            </span>
            {renderListHelper(
              { items, style },
              {
                items: highlightItemHere?.items,
                position:
                  index === highlightPositionOnThisLevel && highlightPositionOnNextLevel
                    ? highlightPositionOnNextLevel
                    : '',
              },
            )}
          </li>
        );
      })}
    </Tag>
  );
};

export const renderList = (listBlockData: TListBlockData, highlightData?: TListHighlightBlockData) => {
  if (!highlightData) {
    return renderListHelper(listBlockData);
  }

  const highlightPosition = findListFragmentPositionInList(listBlockData, highlightData);
  return renderListHelper(
    listBlockData,
    highlightPosition ? { ...highlightData, position: highlightPosition.replace('root.', '') } : undefined,
  );
};
